module.exports = __webpack_public_path__ + "static/media/semRegistros.3113a1bb.PNG";